import { BrowserRouter, Routes, Route } from 'react-router-dom'
import useWhatsAppTracking from './hooks/useWhatsAppTracking'
import ScrollToTop from './components/ScrollToTop'
import UtilityBar from './components/UtilityBar'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import WhatsAppButton from './components/WhatsAppButton'
import Home from './pages/Home'
import TrekPage from './pages/TrekPage'
import Departures from './pages/Departures'
import About from './pages/About'
import Blog from './pages/Blog'
import BlogPost from './pages/BlogPost'
import PrivacyPolicy from './pages/PrivacyPolicy'

export default function App() {
  useWhatsAppTracking()

  return (
    <BrowserRouter>
      <ScrollToTop />
      <UtilityBar />
      <Navbar />
      <Routes>
        <Route path="/"                    element={<Home />} />
        <Route path="/manaslu-circuit"     element={<TrekPage slug="manaslu-circuit" />} />
        <Route path="/everest-base-camp"   element={<TrekPage slug="everest-base-camp" />} />
        <Route path="/annapurna-circuit"   element={<TrekPage slug="annapurna-circuit" />} />
        <Route path="/annapurna-base-camp" element={<TrekPage slug="annapurna-base-camp" />} />
        <Route path="/langtang-valley"     element={<TrekPage slug="langtang-valley" />} />
        <Route path="/langtang-gosaikunda" element={<TrekPage slug="langtang-gosaikunda" />} />
        <Route path="/departures"          element={<Departures />} />
        <Route path="/about"               element={<About />} />
        <Route path="/blog"                element={<Blog />} />
        <Route path="/blog/:slug"          element={<BlogPost />} />
        <Route path="/privacy"             element={<PrivacyPolicy />} />
      </Routes>
      <Footer />
      <WhatsAppButton />
    </BrowserRouter>
  )
}
